var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative","height":"30px"},attrs:{"id":"wrapper"}},[_c('horizontal-bar-chart',{ref:"chart",staticStyle:{"height":"30px"},attrs:{"chartData":_vm.chartData,"options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }